// 顶栏下拉菜单共享状态（2026-08-31）
// 账号 / 语言两处下拉收敛为同一套交互语义：
//   - 互斥：同一时刻仅一个展开，打开任意一个自动收起其它
//   - 由各自组件保留内部 trigger/panel 引用处理"点击内部不关闭、点击外部关闭自身"
// 根因修复：账号按钮曾用 @click.stop 阻断 document 冒泡，导致语言下拉收不到外部点击。
// 本 composable 将状态收敛到模块级 reactive（同源共享），两下拉 toggle 时互斥即可，无需跨组件调用。

import { computed, reactive } from 'vue'

const menuState = reactive<Record<string, boolean>>({})

export function useHeaderMenu(id: string) {
  const open = computed(() => !!menuState[id])

  /** 翻转当前菜单；翻转前关闭其它所有菜单（互斥） */
  function toggle() {
    for (const k of Object.keys(menuState)) {
      if (k !== id) menuState[k] = false
    }
    menuState[id] = !menuState[id]
  }

  function close() {
    menuState[id] = false
  }

  return { open, toggle, close }
}